import dayjs from 'dayjs';

export function formatDateUS(date: string) {
  return dayjs(date).format('MM/DD/YY');
}

export function formatDateTimeUS(date: string) {
  return dayjs(date).format('MM/DD/YY - hh:mm a');
}
